import { withCurrentParams } from 'actions/utils';
import { BROADCAST_UPDATE_SOURCE_THUMBNAIL } from 'actions/Types';
import { updateScenesPreview } from 'actions/Broadcast';
import { EMPTY_THUMBNAIL, getSignedUrl } from 'utils/broadcastSourceHelper';

export default (sourceId, changes) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const {
        broadcastSources: { sources }
      } = getState();

      const sourceObject = sources.find(source => source._id === sourceId);
      const action = {
        type: BROADCAST_UPDATE_SOURCE_THUMBNAIL,
        request: async apiClient => {
          const response = await apiClient.broadcast.updateSource(
            teamId,
            eventId,
            broadcastId,
            sourceId,
            changes
          );

          const updatedSource = await getSignedUrl(response, apiClient);
          // When thumbnail exists already we want to skip this.
          if (
            sourceObject &&
            (!sourceObject.thumbnail ||
              sourceObject.thumbnail === EMPTY_THUMBNAIL)
          ) {
            dispatch(updateScenesPreview(sourceId, changes.thumbnail));
          }
          return updatedSource;
        }
      };
      dispatch(action);
    }
  );
};
